import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { TournamentsService } from './../tournaments/services/tournaments.service';
declare let $;
declare let SetLanguage: any;
@Component({
    selector: 'comp_terminal_keyboard_modal',
    templateUrl: './terminal_keyboard_modal.html',
})
export class TerminalKeyboardModal implements OnInit {
    constructor(public tournamentsService: TournamentsService) {}

    TerminalKeyboard_Input_Value = '';
    //@Input('TerminalKeyBoardValue') TerminalKeyBoardValue;
    @Output('TerminalKeyBoardValue') TerminalKeyBoardValue = new EventEmitter();
    init: boolean;
    ngOnInit() {
        if (this.init) return;
        this.init = true;
    }

    TerminalKeyboard_ChangeValue(e) {
        this.TerminalKeyboard_Input_Value += e;

        this.tournamentsService.KeyboardValue += e;

        this.TerminalKeyBoardValue.next(this.TerminalKeyboard_Input_Value);
    }

    TerminalKeyboard_Backspace() {
        this.TerminalKeyboard_Input_Value = this.TerminalKeyboard_Input_Value.slice(0, -1);
        this.tournamentsService.KeyboardValue = this.tournamentsService.KeyboardValue.slice(0, -1);

        this.TerminalKeyBoardValue.next(this.TerminalKeyboard_Input_Value);
    }

    TerminalKeyboard_Close() {
        this.TerminalKeyboard_Input_Value = '';
        this.tournamentsService.KeyboardValue = '';

        this.TerminalKeyBoardValue.next(this.TerminalKeyboard_Input_Value);
        $('#Terminal_Keyboard_Modal').modal('hide');
    }
    TerminalKeyboard_InputClear() {
        //console.log("CLEAR");
        this.tournamentsService.KeyboardValue = '';
        this.TerminalKeyboard_Input_Value = '';

        this.TerminalKeyBoardValue.next(this.TerminalKeyboard_Input_Value);
    }
}
